export default {

  slider : "اسلایدر",
  post: "پست",
  bus: "اتوبوس",
  tipax: "تیپاکس",
  freight:"باربری",
  hour: "ساعت",
  toman:"تومان",
  kit_items: "کیت و اقلام",
  totalPrice: "قیمت کل",
  items_count: "تعداد اقلام",
  devices_count: "تعداد دستگاه",
  reception: "پذیرش",
  userType: "نوع کاربر",
  customer: "مشتری",
  representative: "نماینده",
  userInfo: "اطلاعات کاربر",
  devices: "دستگاه ها",
  IMEI: "imei",
  devide_model: "مدل دستگاه",
  serial: "سریال",
  addDevice: "افزودن دستگاه",
  approximateTime: "زمان تقریبی",
  returned: "مرجوع",
  guarantee: "گارانتی",
  status: "وضعیت",
  items: "اقلام",
  addItems: "افزودن اقلام",
  confused: "مخدوش",
  new: "نو",
  broken: "خراب",
  Confirmation_of_registration_and_transfer_to_the_acceptance_stage: "تایید ثبت و انتقال به مرحله پذیرش",
  confirm_transfer_to_accepted: "تایید و انتقال به پذیرش شده ها",
  transfer_to_repair_stage: "ارسال به مرحله تعمیرات",
  send_sms_to_customer: "ارسال پیامک به مشتری",
  finalRegister: "ثبت نهایی",
  addProduct: "افزودن محصول",
  products: "محصولات",
  newReception: "پذیرش جدید",
  receptionList: "لیست پذیرش شده ها",
  city: "شهر",
  show: "نمایش",
  to: "تا",
  repairs_diagnostic: "تشخیص ",
  during_diagnosis_repairs: "در جریان تعمیرات تشخیص",
  current_sheet: "برگه جاری",
  diagnosis_sheet: "برگه تشخیص",
  diagnosis: "تشخیص",
  price: "قیمت",
  parts: "قطعات",
  replacement_parts: "قطعات تعویضی",
  healthy_parts: "قطعات سالم",
  add_part: "افزودن قطعه",
  send_to_checkout_page: "ارسال به برگه خروج",
  issuing_diagnosis_card: "صدور برگه تشخیص",
  checkout_page: "برگه خروج",
  wait_to_confirm: "در انتظار تایید",
  changeStatus: "تغییر وضعیت",
  be_confirm: "  تایید شده",
  be_send: "ارسال شده",
  customers: "مشتریان",

  registerDate: "تاریخ ثبت",
  action: "عملیات",
  active: "فعال",
  activity: "فعالیت",
  owner: "مالک",
  name: "نام",
  add: "افزودن",
  checkDevice: "چک دستگاه",
  addUser: "ثبت کاربر",
  address: "آدرس",
  deviceId: "شناسه دستگاه",
  addresses: "آدرس‌ها",
  cleaningFacilities: "تاسیسات نظافت",
  cleaning: "نظافت",
  facilities: "تاسیسات",
  discountCodePrice: "مبلغ کد تخفیف",
  base_price: "قیمت پایه",
  percent: "درصد",
  socialNetworks: "شبکه های اجتماعی",
  orderCode: "کد سفارش",
  toman: "تومان",
  tastingTray: "سینی مزه",
  rulesAndRegulations: "قوانین و مقررات",
  aboutUs: "درباره ما",
  ourBranches: "شعبه های ما",
  fax: "فکس",
  privacy: "حریم خصوصی",
  addressHint:
    "ابتدا محدوده را روی نقشه مشخص و سپس آدرس را به صورت کامل وارد کنید",
  admin: "مدیر",
  remittance: "حواله های واریزی",
  all: "همه",
  code: "کد",
  tax: "مالیات",
  shipping: "هزینه حمل",
  bazaar: "بازارچه",
  coffeeShop: "کافی شاپ",
  hospitality: "مهمانداری",
  discountCode: "کد تخفیف",
  expireDate: "تاریخ انقضا",
  expiryDate: "تاریخ انقضا",
  taste: "مزه",
  usageLimit: "تعداد دفعات استفاده",
  amount: "مبلغ",
  android: "اندروید",
  answer: "پاسخ",
  app: "اپلیکیشن",
  CANCELLED: "لغو شده",
  backHome: "بازگشت به صفحه اصلی",
  bankInfo: "اطلاعات دریافتی از بانک",
  personCode: "کد اشخاص",
  barcode: "بارکد",
  basedOnMeters: "بر اساس متر",
  birthdate: "تاریخ تولد",
  bottom: "پایین",
  brand: "برند",
  bronze: "برنزی",
  buy: "خرید",
  calcPerMonth: "مبلغ خرید بر حسب ماه",
  cancel: "لغو",
  canceled: "لغو شده",
  cash: "نقدی",
  cardReader: "کارت خوان",
  carrier: "حمل کننده",
  category: "دسته‌بندی",
  banks: "بانک ها",
  bank: "بانک",
  center: "وسط",
  choose: "انتخاب کنید",
  chooseImage: "انتخاب تصویر",
  chooseLocation: "انتخاب مکان",
  client: "سفارش دهنده",
  close: "بستن",
  confirm: "تایید",
  password: "رمز عبور",
  confirmAddVIP: "از VIP کردن این کاربر اطمینان دارید؟",
  confirmCancelOrder: "از لغو این سفارش اطمینان دارید؟",
  confirmCatActivate: "از فعال کردن این دسته‌بندی اطمینان دارید؟",
  confirmCatDeactivate: "از غیرفعال کردن این دسته‌بندی اطمینان دارید؟",
  confirmDelete: "از حذف این آیتم اطمینان دارید؟",
  confirmDeleteCat: "از حذف این دسته‌بندی اطمینان دارید؟",
  confirmDeleteBank: "از حذف این بانک اطمینان دارید؟",
  confirmDeleteImage: "از حذف این تصویر اطمینان دارید؟",
  confirmDeleteMessage: "از حذف این پیام اطمینان دارید؟",
  confirmDeleteOffer: "از حذف این پیشنهاد اطمینان دارید؟",
  confirmDeleteOrder: "از حذف این سفارش اطمینان دارید؟",
  confirmDeleteProduct: "از حذف این محصول اطمینان دارید؟",
  confirmDeleteUser: "از حذف این کاربر اطمینان دارید؟",
  confirmDelVIP: "از غیر VIP کردن این کاربر اطمینان دارید؟",
  confirmActivate: "از فعال کردن این آیتم اطمینان دارید؟",
  confirmDeactivate: "از غیرفعال کردن این آیتم اطمینان دارید؟",
  confirmOfferActivate: "از فعال کردن این پیشنهاد اطمینان دارید؟",
  confirmOfferDeactivate: "از غیرفعال کردن این پیشنهاد اطمینان دارید؟",
  confirmProductActivate: "از فعال کردن این محصول اطمینان دارید؟",
  confirmProductDeactivate: "از غیرفعال کردن این محصول اطمینان دارید؟",
  confirmSuspendOrder: "از تعلیق این سفارش اطمینان دارید؟",
  confirmText: "آیا اطمینان دارید؟",
  confirmUserActivate: "از فعال کردن این کاربر اطمینان دارید؟",
  confirmUserDeactivate: "از غیرفعال کردن این کاربر اطمینان دارید؟",
  contactInfo: "اطلاعات تماس",
  continuation: "ادامه",

  count: "تعداد",
  countPredictedDistance: "تعداد ارسال محصولات",
  courierList: "لیست پیک‌ها",
  credit: "اعتبار",
  credential: "اعتباری",
  dashboard: "پیشخوان",
  dataEntries: "ورودی‌ها",
  date: "تاریخ",
  startHour: "ساعت شروع",
  endHour: "ساعت پایان",
  hour: "ساعت",
  dateAndTime: "ساعت و تاریخ",
  dailyPosition: "تعداد فروش امروز",
  decrease: "کاهش",
  dedicated: "اختصاصی",
  delete: "حذف",
  delivered: "ارسال شده",
  delivery: "پیک",
  description: "توضیحات",
  details: "جزئیات",
  device: "دستگاه",
  drafts: "پیش‌نویس‌ها",
  discount: "تخفیف",
  edit: "ویرایش",
  email: "ایمیل",
  endDate: "تاریخ پایان",
  enter: "ورود",
  enterCode: "کد پیامک را وارد کنید",
  enterMobile: "شماره همراه را وارد کنید",
  errorJpg: "شما فقط می‌توانید تصویر jpg بارگذاری کنید",
  errorPng: "شما فقط می‌توانید تصویر png بارگذاری کنید",
  factor: "فاکتور",
  faq: "سوالات متداول",

  firstName: "نام",
  finalPrice: "قابل پرداخت",
  four: "چهار",
  from: "از",
  fromDate: "از تاریخ",
  fullName: "نام و نام خانوادگی",
  gold: "طلایی",
  grouping: "گروهی",
  image: "تصویر",
  images: "تصاویر",
  inactive: "غیرفعال",
  increase: "افزایش",
  information: "اطلاعات",
  inside: "محدوده",
  instagram: "اینستاگرام",
  inventory: "موجودی انبار",
  ios: "آی او اس",
  key: "کلید",
  lastName: "نام‌خانوادگی",
  latitude: "طول جغرافیایی",
  link: "لینک",
  list: "لیست",
  loading: "در حال بارگذاری...",
  location: "موقعیت",
  login: "ورود",
  logout: "خروج از پنل",
  longitude: "عرض جغرافیایی",
  main: "اصلی",
  message: "پیام",
  messages: "پیام‌ها",
  mobile: "موبایل",
  mobileHint: "09152222222",
  mobilePhone: "تلفن همراه / ثابت",
  mobilePhoneHint: "09152222222 / 0513222222",
  month: "ماه",
  move: "حرکت",
  nameHint: "ترجیحا به صورت فارسی وارد کنید",
  new: "جدید",
  no: "خیر",
  normal: "معمولی",
  notfound: "متأسفیم، چنین صفحه‌ای وجود ندارد.",
  notfoundCode: "۴۰۴",
  one: "یک",

  other: "سایر",
  otherPhones: "سایر تلفن‌ها",
  outside: "خارج",
  patterns: "اطلاعات وارد شده صحیح نمی‌باشد",
  payment: "پرداخت",
  permission: "دسترسی",
  permissions: "دسترسی‌ها",
  phone: "تلفن",


  rank: "رتبه",
  record: "ثبت",
  recordAndPrint: "ثبت و پرینت",
  print: "پرینت",
  receive: "دریافت",
  receivedMessage: "پیام‌های دریافتی",

  report: "گزارش",
  required: "این فیلد الزامی می‌باشد",
  returned: "مرجوعی",
  rial: "ريال",

  shareFriends: "معرفی به دوستان",
  search: "جستجو...",
  searchHintCategory: "عنوان",
  searchHintMessageUser: "نام و نام خانوادگی، تلفن همراه",

  searchHintUser: "نام و نام خانوادگی، تلفن همراه و ثابت",
  section: "بخش",
  select: "انتخاب",
  sellingPrices: "مقدار فروش امروز",
  sendCode: "ارسال کد",
  sendNotif: "ارسال نوتیفیکیشن",

  serverError: "مشکلی در انجام عملیات به وجود آمده است",
  serverSuccess: "عملیات با موفقیت انجام شد",
 
 
  sendWith: "ارسال با",
  two: "دو",
  type: "نوع",
  unauthorized: "متأسفیم، شما به این صفحه دسترسی ندارید.",
  unauthorizedCode: "۴۰۳",
  unknown: "ناشناس",
  successful: "موفق",
  unsuccessful: "ناموفق",
  uploadError: "مشکلی در ارسال فایل به وجود آمده است",
  uploadImage: "بارگذاری تصویر",
  uploadSuccess: "فایل با موفقیت بارگذاری شد",
  uploadText:
    "برای بارگیری عکس، روی این منطقه کلیک کنید یا عکس را اینجا رها کنید",
  user: "کاربر",

  users: "کاربران",

  yes: "بله",


  repaireManagementPanel: "پنل مدیریت تعمیرات"
};
